import CashCount from 'src/models/cash/CashCount'
import CashSession from 'src/models/cash/CashSession'
import Model, { encoders, ID, MODEL_LEVEL } from 'src/models/model'
import Archivable from 'src/models/model/concerns/Archivable'
import RegisterStation from 'src/models/register/RegisterStation'

export default class CashTray extends Model {
  static name = 'CashTray'

  static level = MODEL_LEVEL.SITE

  static duplicatable = true
  static versioned = true

  static employeeRequiredPermissionCategories = [Model.permissionCategories.PointOfSale, Model.permissionCategories.HardwareAndRegisterStation]

  static define () {
    this.concerns = [Archivable]

    this.fields = {
      id: {
        type: ID,
        required: true
      },

      name: {
        type: String
      },
      siteId: {
        type: ID,
        output: true
      },
      initializeCashCount: {
        type: Boolean,
        default: false
      },
      bank: {
        type: Number,
        encode: encoders.cents,
        default: 0
      },
      enableRegisterStationRestriction: {
        type: Boolean,
        default: false
      },
      registerStations: {
        type: [RegisterStation],
        default: () => ([]),
        reference: true
      },

      activeCashCount: {
        type: CashCount,
        output: true,
        default: null
      },
      activeCashSession: {
        type: CashSession,
        output: true,
        default: null
      },
      lastCashSession: {
        type: CashSession,
        output: true,
        default: null
      }
    }
  }
}
